<template>
    <div class="layout-pods orders">
        <header class="layout-pods-header pg-header mt-5">
            <div></div>
        </header>
        <div class="">
            <div class="row">
                <div class="col-12">
                    <template>
                        <div>
                            <div class="row">
                                <div class="col-6 col-md-4 col-lg-2 mb-2 mr-2">
                                    <multiselect placeholder="Filter by Client" v-model="client" name="client" label="title"
                                        track-by="id" :options="clients" @input="getLogs(pagination.currentPage)">
                                    </multiselect>
                                </div>
                                <div class="col-6 col-md-4 col-lg-2 mb-2 mr-2">
                                    <multiselect placeholder="Select limit" v-model="limit" :options="[10, 20, 50, 100]"
                                        @input="() => getLogs(pagination.currentPage)">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <br>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Client</th>
                    <th>Campaign</th>
                    <th>Type</th>
                    <th>Logged Date</th>
                    <th>Request</th>
                    <th>Response</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="log in logs" :key="log.id">
                    <td>{{ log.client && log.client.title ? log.client.title : null }}</td>
                    <td>{{ log.campaign && log.campaign.property && log.campaign.property.title ?
                        log.campaign.property.title : null }}</td>
                    <td>{{ log.type }}</td>
                    <td>{{ formatDate(log.updatedAt) }}</td>
                    <td>
                        <button @click="selectedLog = log.request; showModal = true" class="btn btn-primary">
                            Click to view
                        </button>
                    </td>
                    <td>
                        <button @click="selectedLog = log.response; showModal = true" class="btn btn-primary">
                            Click to view
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <button class="btn btn-secondary btn-square" @click="getLogs(pagination.currentPage - 1)">Previous</button>
        <button class="btn btn-secondary btn-square" @click="getLogs(pagination.currentPage + 1)">Next</button>
        <log-modal :show-modal.sync="showModal" :json-response="selectedLog"></log-modal>
    </div>
</template>

<script>
import SignifiLogServices from '../../services/signifiLogs';
import LogModal from './LogModal.vue';
import Multiselect from "vue-multiselect";
import ClientService from '../../services/clients';
import NavigationPerimeters from '../../configs/Perimeters/navigation';

export default {
    name: 'SignifiLogs',
    components: {
        LogModal,
        Multiselect
    },
    data() {
        return {
            logs: [],
            showModal: false,
            selectedLog: null,
            campaign: null,
            clients: [],
            client: '',
            pagination: {
                currentPage: 1,
                totalPages: 0,
            },
            limit: 10,
        };
    },
    methods: {
        getLogs(page = 1) {
            if (page < 1) {
                page = 1;
            }

            this.pagination.currentPage = page;
            const params = {
                page: this.pagination.currentPage,
                limit: this.limit || 10
            };

            if (this.campaign) {
                params.campaign = this.campaign;
            }

            if (this.client) {
                params.client = this.client.id;
            }

            console.log(params);
            SignifiLogServices.getLogs(params).then(response => {
                this.logs = response.data;
                this.pagination.currentPage = response.cursor.current.cursor;
                this.pagination.totalPages = response.cursor.count;
            }).catch(error => {
            });

        },
        formatDate(dateString) {
            let date = new Date(dateString);
            return date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) + ' ' + date.toLocaleTimeString('en-US');
        },
        getClients() {
            ClientService.getClients().then(results => {
                this.clients = results.data;
            })
        },
    },
    mounted() {
        this.campaign = this.$route.params.campaignId;
        this.getClients();
        this.getLogs(this.pagination.currentPage);
    },
};
</script>
<style scoped>
.btn-square {
    border-radius: 0;
    margin-right: 5px;
    margin-top: 5px;
}
</style>